import styled from 'styled-components';
import { colorCSS } from '../../../styles';
const width = 24;
const height = 24;
const lineWidth = 3;
export const Icon = styled.div `
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: block;
  height: ${height}px;
  margin: 0;
  padding: 0;
  position: relative;
  width: ${width}px;

  span {
    background-color: ${colorCSS('N800')};
    border-radius: ${lineWidth}px;
    display: block;
    height: ${lineWidth}px;
    left: 0;
    opacity: 1;
    position: absolute;
    transform: rotate(0deg);
    transition: 0.3s ease;
    width: ${width}px;

    ${({ isOpen }) => isOpen
    ? `
      &:nth-child(1) {
        left: 0px;
        top: ${(height - lineWidth) / 2}px;
        transform: rotate(45deg);
      }

      &:nth-child(2) {
        top: ${(height - lineWidth) / 2}px;
        opacity: 0;
        width: 0%;
      }

      &:nth-child(3) {
        left: 0px;
        top: ${(height - lineWidth) / 2}px;
        transform: rotate(-45deg);
      }
      `
    : `
      &:nth-child(1) {
        top: ${lineWidth / 2}px;
        transform-origin: left center;
      }
  
      &:nth-child(2) {
        top: ${(height - lineWidth) / 2}px;
        transform-origin: left center;
      }
  
      &:nth-child(3) {
        top: ${height - lineWidth * 1.5}px;
        transform-origin: left center;
      }
        
      `}
  }
`;
//# sourceMappingURL=MenuIcon.styles.js.map